import graphql from '../utils/graphql';
export default {
  async getSedes({ commit, state }, { fspCodigo, sadCodigo }) {
    let sedes = state.sedes.filter(x => x.fspCodigo == fspCodigo);
    if (!sedes.length) {
      const query = {
        query: `query ($fspCodigo: Int!, $sadCodigo: Int!) {
          sedes: sedesByFaseSecretaria(fspCodigo: $fspCodigo, sadCodigo: $sadCodigo) {
            fspCodigo
            sedCodigo
            sede {
              sadCodigo
              sedNombre
              regCodigo
              prvCodigo
              comCodigo
            }
            sedeConfirmada {
              estado
            }
          }
        }
        `,
        variables: {
          fspCodigo,
          sadCodigo,
        }
      };
      ({ sedes } = await graphql.request(query));
      if (sedes.length) {
        commit('setSedes', sedes);
      }
    }
    return sedes.filter(({ sede }) => sede.sadCodigo == sadCodigo);
  },
  async getFunciones({ commit, state }, { ids }) {
    let funciones = state.funciones.filter(({fneCodigo}) => [ids].includes(fneCodigo));
    if (!funciones.length) {
      const query = {
        query: `query ($ids: [Int!]!) {
          funciones: funcionesExaminador(ids: $ids) {
            fneCodigo
            nombre
          }
        }
        `,
        variables: {
          ids,
        }
      };
      ({ funciones } = await graphql.request(query));
      if (funciones.length) {
        commit('setFunciones', funciones);
      }
    }
    return funciones;
  },
  async getPaises({ commit, getters }) {
    if (!getters.getPaises.length) {
      try {
        const query = {
          query: ` query {
            paises {
              codigo
              nombre
            }
          }
          `,
        };
      const { paises } = await graphql.request(query);
      commit('setPaises', paises.filter(p=> p.codigo !== 296)); // Filtra opcion Prefiero no responder
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },
  async getProceso({ commit, getters }) {
    if (Object.keys(getters.getProceso).length === 0) {
      try {
        const query = {
          query: ` query {
            proceso: getProcesoVigente {
              secuencia
              nombre
              anioPromocion
            }
          }
          `,
        };
      const { proceso } = await graphql.request(query);
      commit('setProceso', proceso);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },
};
